import { render, staticRenderFns } from "./SimilarModal.vue?vue&type=template&id=ebd5319c&scoped=true"
import script from "./SimilarModal.vue?vue&type=script&lang=js"
export * from "./SimilarModal.vue?vue&type=script&lang=js"
import style0 from "./SimilarModal.vue?vue&type=style&index=0&id=ebd5319c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd5319c",
  null
  
)

export default component.exports